"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var motorSettings = {
    "Nema 17 Stepper": {
        value: "Nema 17 Stepper",
        motorCurrent: {
            minimum: 1.5,
            maximum: 1.68,
            default: 1.68
        },
        allowedAxisType: [
            "electric_cylinder",
            "custom"
        ],
        controlLoop: "open"
    },
    "Small Servo": {
        value: "Small Servo",
        motorCurrent: {
            minimum: 1.5,
            maximum: 10.0,
            default: 10
        },
        allowedAxisType: [
            "belt",
            "rack_and_pinion",
            "rack_and_pinion_v2",
            "ball_screw",
            "enclosed_ball_screw",
            "enclosed_lead_screw",
            "indexer",
            "indexer_v2",
            "belt_conveyor",
            "roller_conveyor",
            "enclosed_timing_belt",
            "belt_rack",
            "heavy_duty_roller_conveyor",
            "timing_belt_conveyor",
            "custom"
        ],
        tuningProfile: true,
        controlLoop: "closed"
    },
    "Medium Servo": {
        value: "Medium Servo",
        motorCurrent: {
            minimum: 1.5,
            maximum: 10.0,
            default: 10
        },
        allowedAxisType: [
            "belt",
            "rack_and_pinion",
            "rack_and_pinion_v2",
            "ball_screw",
            "enclosed_ball_screw",
            "enclosed_lead_screw",
            "indexer",
            "indexer_v2",
            "belt_conveyor",
            "roller_conveyor",
            "enclosed_timing_belt",
            "belt_rack",
            "heavy_duty_roller_conveyor",
            "timing_belt_conveyor",
            "custom"
        ],
        tuningProfile: true,
        controlLoop: "closed"
    },
    "Large Servo": {
        value: "Large Servo",
        motorCurrent: {
            minimum: 1.5,
            maximum: 10.0,
            default: 10
        },
        allowedAxisType: [
            "belt",
            "rack_and_pinion",
            "rack_and_pinion_v2",
            "ball_screw",
            "enclosed_ball_screw",
            "enclosed_lead_screw",
            "indexer",
            "indexer_v2",
            "belt_conveyor",
            "roller_conveyor",
            "enclosed_timing_belt",
            "belt_rack",
            "heavy_duty_roller_conveyor",
            "timing_belt_conveyor",
            "telescopic_column",
            "custom"
        ],
        tuningProfile: true,
        controlLoop: "closed"
    }
};
var _default = motorSettings;
